module.exports = __webpack_public_path__ + "static/media/cityscape.b403bea2.webp";